module.exports = __webpack_public_path__ + "static/background-3-ce327be1d1e6f4976202c26b6b2bfd8c.jpg";